// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promo-code{height:-moz-fit-content;height:fit-content;padding:4px 30px;gap:8px;width:100%;background:#ccebff;margin-top:2px;font-size:.9em}.promo-code button{height:12px;width:12px}", ""]);
// Exports
module.exports = exports;
